import { render, staticRenderFns } from "./ShippingCostListSettings.vue?vue&type=template&id=0fe0150c&scoped=true&"
import script from "./ShippingCostListSettings.vue?vue&type=script&lang=js&"
export * from "./ShippingCostListSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe0150c",
  null
  
)

export default component.exports